const mockFollowers = [
  {
    login: 'ronenhamias',
    id: 1706296,
    node_id: 'MDQ6VXNlcjE3MDYyOTY=',
    avatar_url: 'https://avatars.githubusercontent.com/u/1706296?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/ronenhamias',
    html_url: 'https://github.com/ronenhamias',
    followers_url: 'https://api.github.com/users/ronenhamias/followers',
    following_url:
      'https://api.github.com/users/ronenhamias/following{/other_user}',
    gists_url: 'https://api.github.com/users/ronenhamias/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/ronenhamias/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/ronenhamias/subscriptions',
    organizations_url: 'https://api.github.com/users/ronenhamias/orgs',
    repos_url: 'https://api.github.com/users/ronenhamias/repos',
    events_url: 'https://api.github.com/users/ronenhamias/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/ronenhamias/received_events',
    type: 'User',
    site_admin: false,
  },
  {
    login: 'opengineer',
    id: 32831059,
    node_id: 'MDQ6VXNlcjMyODMxMDU5',
    avatar_url: 'https://avatars.githubusercontent.com/u/32831059?v=4',
    gravatar_id: '',
    url: 'https://api.github.com/users/opengineer',
    html_url: 'https://github.com/opengineer',
    followers_url: 'https://api.github.com/users/opengineer/followers',
    following_url:
      'https://api.github.com/users/opengineer/following{/other_user}',
    gists_url: 'https://api.github.com/users/opengineer/gists{/gist_id}',
    starred_url:
      'https://api.github.com/users/opengineer/starred{/owner}{/repo}',
    subscriptions_url: 'https://api.github.com/users/opengineer/subscriptions',
    organizations_url: 'https://api.github.com/users/opengineer/orgs',
    repos_url: 'https://api.github.com/users/opengineer/repos',
    events_url: 'https://api.github.com/users/opengineer/events{/privacy}',
    received_events_url:
      'https://api.github.com/users/opengineer/received_events',
    type: 'User',
    site_admin: false,
  },
];

export default mockFollowers;
